export function CountryEmpty({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="200"
        height="116"
        viewBox="0 0 200 116"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M150.997 20.7447C143.07 24.8888 137.513 30.9903 134.325 39.0493"
          stroke="var(--clr-title)"
          strokeOpacity="0.2"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeDasharray="1 7"
        />
        <path
          opacity="0.9"
          d="M154.925 16.6733C160.704 12.3611 166.802 14.0405 168.118 19.9791C162.233 22.2941 157.134 20.5618 154.925 16.6733Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.65"
          d="M154.924 16.6733C152.609 10.7877 156.339 5.5828 162.331 5.26496C162.648 11.2565 159.865 15.4098 154.924 16.6733Z"
          fill="var(--clr-general-primary)"
        />
        <path
          d="M100 111C126.51 111 148 89.5097 148 63C148 36.4903 126.51 15 100 15C73.4903 15 52 36.4903 52 63C52 89.5097 73.4903 111 100 111Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path opacity="0.5" d="M100 15C72 39 72 87 100 111" stroke="var(--clr-general-primary)" />
        <path opacity="0.5" d="M100 15C128 39 128 87 100 111" stroke="var(--clr-general-primary)" />
        <path
          opacity="0.5"
          d="M100 15V49"
          stroke="var(--clr-general-primary)"
          strokeLinecap="round"
        />
        <path
          opacity="0.5"
          d="M100 87V111"
          stroke="var(--clr-general-primary)"
          strokeLinecap="round"
        />
        <path
          opacity="0.5"
          d="M54 63H74"
          stroke="var(--clr-general-primary)"
          strokeLinecap="round"
        />
        <path
          opacity="0.5"
          d="M126 63H146"
          stroke="var(--clr-general-primary)"
          strokeLinecap="round"
        />
        <path
          opacity="0.5"
          d="M66 39H134"
          stroke="var(--clr-general-primary)"
          strokeLinecap="round"
        />
        <path
          opacity="0.5"
          d="M66 87H134"
          stroke="var(--clr-general-primary)"
          strokeLinecap="round"
        />
        <path
          d="M84 63C88 67.6667 92 67.6667 96 63"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          d="M104 63C108 67.6667 112 67.6667 116 63"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          d="M92 77C97.3333 81 102.667 81 108 77"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          opacity="0.18"
          d="M78.5 75.5C80.1569 75.5 81.5 74.1569 81.5 72.5C81.5 70.8431 80.1569 69.5 78.5 69.5C76.8431 69.5 75.5 70.8431 75.5 72.5C75.5 74.1569 76.8431 75.5 78.5 75.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.18"
          d="M118.5 75.5C120.157 75.5 121.5 74.1569 121.5 72.5C121.5 70.8431 120.157 69.5 118.5 69.5C116.843 69.5 115.5 70.8431 115.5 72.5C115.5 74.1569 116.843 75.5 118.5 75.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.45"
          d="M30 52L32 57L37 59L32 61L30 66L28 61L23 59L28 57L30 52Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.4"
          d="M49.6 13.2C51.0359 13.2 52.2 12.0359 52.2 10.6C52.2 9.16406 51.0359 8 49.6 8C48.1641 8 47 9.16406 47 10.6C47 12.0359 48.1641 13.2 49.6 13.2Z"
          fill="var(--clr-general-primary)"
        />
      </svg>
    </span>
  );
}
